import { Injectable } from '@angular/core';

interface Quote {
  text: string;
  author: string;
}

const QUOTES: Quote[] = [
  { text: 'The only way to do great work is to love what you do.', author: 'Steve Jobs' },
  { text: 'Innovation distinguishes between a leader and a follower.', author: 'Steve Jobs' },
  { text: 'Stay hungry, stay foolish.', author: 'Steve Jobs' },
  { text: 'The best way to predict the future is to invent it.', author: 'Alan Kay' },
  { text: 'Simplicity is the ultimate sophistication.', author: 'Leonardo da Vinci' },
  { text: 'Done is better than perfect.', author: 'Sheryl Sandberg' },
  { text: 'First, solve the problem. Then, write the code.', author: 'John Johnson' },
  { text: 'Make it work, make it right, make it fast.', author: 'Kent Beck' },
  { text: 'Quality is not an act, it is a habit.', author: 'Aristotle' },
  { text: 'Code is like humor. When you have to explain it, it is bad.', author: 'Cory House' },
];

@Injectable({ providedIn: 'root' })
export class QuoteService {
  getQuoteOfTheDay(): Quote {
    const dayOfYear = Math.floor(
      (Date.now() - new Date(new Date().getFullYear(), 0, 0).getTime()) / 86400000
    );
    return QUOTES[dayOfYear % QUOTES.length];
  }
}
